export default __webpack_public_path__ + "static/media/cebu-south.3fd0fbe0.jpg";